import { z } from 'zod';

/**
 * Validation schema for a single seniority
 */
export const senioritySchema = z.object({
  seniorityId: z.number(),
  name: z
    .string()
    .trim()
    .min(1, 'authenticated.settings:pages.seniorities.errors.nameRequired')
    .max(100, 'authenticated.settings:pages.seniorities.errors.nameTooLong'),
  memberCount: z.number(),
});

/**
 * Validation schema for seniorities form
 * Includes duplicate name validation
 */
export const senioritiesFormSchema = z.object({
  seniorities: z.array(senioritySchema).superRefine((seniorities, ctx) => {
    // Check for duplicate names (case-insensitive)
    const names = new Map<string, number>();

    seniorities.forEach((sen, index) => {
      const normalizedName = sen.name.toLowerCase().trim();

      if (normalizedName) {
        const firstIndex = names.get(normalizedName);

        if (firstIndex !== undefined && firstIndex !== index) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: 'authenticated.settings:pages.seniorities.errors.duplicateName',
            path: [index, 'name'],
          });
        } else {
          names.set(normalizedName, index);
        }
      }
    });
  }),
});

/**
 * Validation schema for delete seniority modal
 */
export const deleteSenioritySchema = z.object({
  replacementSeniorityId: z.number().optional(),
});

export type SenioritiesFormData = z.infer<typeof senioritiesFormSchema>;
export type DeleteSeniorityFormData = z.infer<typeof deleteSenioritySchema>;
